import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getSocket } from './socket';

/**
 * Presencia en sala a nivel de navegación.
 *
 * El lobby y el partido son dos rutas de la MISMA sala: pasar de una a otra
 * no debe sacar al jugador. En cambio, salir a cualquier otra ruta (Hub,
 * estadio, login u otra sala) sí debe liberar su plaza para no dejar
 * participantes "fantasma".
 *
 * El tracker vive en el router (siempre montado) y compara la sala de la
 * URL anterior con la actual: no depende de timers ni del orden de
 * montaje/desmontaje, así que funciona igual con rutas lazy y StrictMode.
 * Cerrar la pestaña lo cubre el servidor (desconexión + periodo de gracia).
 */
const ROOM_ROUTE = /^\/(?:lobby|match)\/([^/]+)/;

const roomIdFromPath = (pathname: string): string | null => ROOM_ROUTE.exec(pathname)?.[1] ?? null;

/** Salida explícita e inmediata de una sala (idempotente en servidor). */
export const leaveRoomNow = (roomId: string): void => {
  void getSocket().then((s) => s.emit('room:leave', { roomId }));
};

/** Montar una vez dentro del `<BrowserRouter>`. */
export const useRoomPresenceTracker = (): void => {
  const { pathname } = useLocation();
  const roomId = roomIdFromPath(pathname);
  const previous = useRef<string | null>(null);

  useEffect(() => {
    if (previous.current && previous.current !== roomId) leaveRoomNow(previous.current);
    previous.current = roomId;
  }, [roomId]);
};
